let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("05fo1")).then(() => parcelRequire('194qU'));